// import {
//   handleRouterAfterEach,
//   handleRouterBeforeEach,
//   initialAppLoading,
//   removeAppLoading,
// } from "@/router/router-action"

import {
  initialAppLoading,
  removeAppLoading,
  handleRouterBeforeEach,
  handleRouterAfterEach,
} from "./new-router-action"

import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store/index"

Vue.use(VueRouter)

import { routesSettings } from "./routes-settings"
import { internalRoutesModule1, externalRoutesModule1 } from "./routes-module1"
import { routesModule2 } from "./routes-module2"
import { routesModule3 } from "./routes-module3"
import { routesModule4 } from "./routes-module4"

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    /*
     *
     * LOGIN
     *
     */
    {
      path: "/callback",
      name: "callback",
      component: () => import("@/views/pages/Callback.vue"),
      meta: {
        pageTitle: "Callback",
        hiddenBreadcrumbList: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/pages/Login.vue"),
      meta: {
        pageTitle: "Login",
        layout: "full",
      },
    },
    {
      path: "/internal/login",
      name: "internalLogin",
      component: () => import("@/views/pages/Login.vue"),
      meta: {
        pageTitle: "Internal Login",
        type: "internal",
        layout: "full",
      },
    },

    /*
     *
     * No Permission
     *
     */

    {
      path: "/no-permission",
      name: "noPermission",
      component: () => import("@/views/pages/error/Error404.vue"),
      meta: {
        pageTitle: "No Permission",
        layout: "full",
      },
    },

    /*
     *
     * HOME PAGE
     *
     */
    {
      path: "/",
      name: "home",
      component: () => import("@/views/pages/Home.vue"),
      meta: {
        module: "home",
        pageTitle: "Home",
        type: "external",
        permission: "login",
        breadcrumb: [
          {
            text: "Home",
            active: true,
          },
        ],
      },
    },
    {
      path: "/internal",
      name: "internalHome",
      component: () => import("@/views/pages/Home.vue"),
      meta: {
        module: "home",
        pageTitle: "Home",
        type: "internal",
        permission: "login",
        breadcrumb: [
          {
            text: "Home",
            active: true,
          },
        ],
      },
    },

    ...routesSettings,
    ...internalRoutesModule1,
    ...routesModule2,
    ...routesModule3,
    ...routesModule4,

    ...externalRoutesModule1,

    // {
    //   path: '/error-404',
    //   name: 'error-404',
    //   component: () => import('@/views/error/Error404.vue'),
    //   meta: {
    //     layout: 'full',
    //   },
    // },

    // edit internal account profile
    {
      path: "/internal/edit-profile",
      name: "editProfile",
      component: () => import("@/views/profile/EditProfile.vue"),
      meta: {
        module: "editProfile",
        pageTitle: "Edit Profile",
        type: "internal",
        permission: "login",
        breadcrumb: [
          {
            text: "Edit Profile",
            active: true,
          },
        ],
      },
    },

    {
      path: "*",
      redirect: "no-permission",
    },

    // SELF CHECK-IN
    {
      path: "/self-check-in",
      name: "selfCheckIn",
      component: () => import("@/views/selfCheckIn/SelfCheckIn.vue"),
      meta: {
        hiddenBreadcrumb: true,
        pageTitle: "Self Check-in",
      },
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  initialAppLoading()
  await handleRouterBeforeEach(to, from, next)
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(async (to, from) => {
  await handleRouterAfterEach(to)
  removeAppLoading()
})

export default router
